export default __webpack_public_path__ + "static/media/CGO.d7b4abbb.svg";